import { functions } from "./init";
import { httpsCallable } from "firebase/functions";

type HttpsGetFirebaseTokenRequest = {
  shop: string;
  sessionToken: string;
  clientTimestamp?: string;
};

type HttpsGetFirebaseTokenResponse = string;

const getFirebaseTokenCallable = httpsCallable<HttpsGetFirebaseTokenRequest, HttpsGetFirebaseTokenResponse>(
  functions,
  'https-httpsGetFirebaseToken'
);

export const httpsGetFirebaseToken = async (data: HttpsGetFirebaseTokenRequest) => {
  const result = await getFirebaseTokenCallable(data);
  return result.data;
};

export const httpsSaveShopAsTemplate = async (data?: { shop?: string }) => {
  const callable = httpsCallable<{ shop?: string }, { success: boolean; message: string }>(
    functions,
    'https-httpsSaveShopAsTemplate'
  );
  const result = await callable(data);
  return result.data;
};

export const httpsMigrateSubscriptions = async () => {
  const callable = httpsCallable<any, { success: boolean; message: string }>(
    functions,
    'https-httpsMigrateSubscriptions'
  );
  const result = await callable();
  return result.data;
};

export const httpsGetMentionResourcesList = async (data: { resources: string; search: string; fields: string }) => {
  const callable = httpsCallable<{ resources: string; search: string; fields: string }, any[]>(
    functions,
    'https-httpsGetMentionResourcesList'
  );
  const result = await callable(data);
  return result.data;
};
